import { type I18NMessages } from '@atlaskit/intl-messages-provider';

import { locales } from '../../i18n';
import enMessages from '../../i18n/en';

export const defaultLocale = enMessages;

const localeMap: Record<string, string> = {
	pt: 'pt_BR',
	'pt-PT': 'pt_BR',
	'en-AU': 'en_GB',
};

export const fetchMessagesForLocale = async (locale: string): Promise<I18NMessages | undefined> => {
	try {
		const targetLocale = (localeMap[locale] ?? locale ?? '').replace('-', '_');

		if (!targetLocale) {
			throw new Error('No mapped locale');
		}

		const messages = await locales[targetLocale]();
		return messages.default;
	} catch {
		// ignore
	}

	try {
		const parentLocale = locale.split(/[-_]/)[0];
		const messages = await locales[parentLocale]();
		return messages.default;
	} catch {
		// ignore
	}

	/**
	 * English bundled by default as this is the majority of users
	 */
	return defaultLocale;
};
